import { BolsilloEquipo } from '../../domain/entities/BolsilloEquipo';
import { ResumenHoy } from '../../domain/entities/ResumenHoy';
import { TipoRecaudo } from '../../domain/entities/TipoRecaudo';

export class SaldosApiService {
  private static readonly BASE_URL =
    process.env.REACT_APP_BACKEND_URL ?? 'http://localhost:4000';

  private static async fetchConAuth(url: string, options: RequestInit, pais?: string): Promise<Response> {
    const headers: Record<string, string> = { ...(options.headers as Record<string, string>) };
    if (pais) headers['X-Pais'] = pais;
    const response = await fetch(url, { ...options, headers });
    if (response.status === 401) {
      globalThis.dispatchEvent(new CustomEvent('auth:sesion-expirada'));
      throw new Error('Sesión expirada. Por favor inicia sesión nuevamente.');
    }
    return response;
  }

  static async obtenerBolsilloEquipo(
    equipo: number,
    terminal: number,
    accessToken: string,
    pais: string
  ): Promise<BolsilloEquipo> {
    const params = new URLSearchParams({
      equipo: String(equipo),
      terminal: String(terminal),
    });
    const url = `${this.BASE_URL}/dineros/equipo-bolsillo?${params}`;
    const response = await this.fetchConAuth(url, {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    }, pais);
    if (!response.ok) {
      throw new Error('Error al obtener el saldo del bolsillo');
    }
    const json = await response.json();
    return json.data as BolsilloEquipo;
  }

  static async obtenerResumenHoy(
    equipo: number,
    terminal: number,
    accessToken: string,
    pais: string
  ): Promise<ResumenHoy> {
    const params = new URLSearchParams({
      equipo: String(equipo),
      terminal: String(terminal),
    });
    const url = `${this.BASE_URL}/ventas/dashboard/resumen-hoy?${params}`;
    const response = await this.fetchConAuth(url, {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    }, pais);
    if (!response.ok) {
      throw new Error('Error al obtener el resumen de hoy');
    }
    const json = await response.json();
    return json.data as ResumenHoy;
  }

  static async obtenerTipoRecaudo(
    equipo: number,
    terminal: number,
    fechaInicial: string,
    fechaFinal: string,
    accessToken: string,
    pais: string
  ): Promise<TipoRecaudo[]> {
    const params = new URLSearchParams({
      equipo: String(equipo),
      terminal: String(terminal),
      idMedioPago: '1',
      fechaInicial,
      fechaFinal,
    });
    const url = `${this.BASE_URL}/dineros/tipo-recaudo?${params}`;
    const response = await this.fetchConAuth(url, {
      method: 'GET',
      headers: { Authorization: `Bearer ${accessToken}` },
    }, pais);
    if (!response.ok) {
      throw new Error('Error al obtener el histórico de recaudo');
    }
    const json = await response.json();
    return json.data as TipoRecaudo[];
  }
}
